/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import styled from '@emotion/styled';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Button, Typography2 } from '@coursera/cds-core';
import { color, fontFamily } from '@coursera/coursera-ui';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { getSkillRangeLabelsByScore } from 'bundles/enterprise-admin-skills/utils/skillTargets';
import { Spacer } from 'bundles/enterprise-ui/components/Spacer';
import { truncate } from 'bundles/enterprise-ui/utils';

import _t from 'i18n!nls/enterprise-admin-skills';

export const Proficiencies = styled.div({
  overflowX: 'hidden',
  padding: '6px 0',
});

const Badge = styled.div({
  minWidth: '125px',
  padding: '4px 9px',
  textTransform: 'uppercase',
  fontFamily: fontFamily.bold,
  fontSize: '14px',
  lineHeight: '16px',
  border: `1px solid ${color.divider}`,
});

const LevelBar = styled.div({
  background: 'var(--cds-color-yellow-200)',
  minWidth: '3px',
  marginLeft: '3px',
});

export const SkillSetTargetLevelBadge = ({ targetProficiency }: { targetProficiency: number }) => {
  const { level, index } = getSkillRangeLabelsByScore(targetProficiency);
  return (
    <div css={{ display: 'flex' }}>
      <Badge>{level}</Badge>
      {[...Array(index + 1).keys()].map((key) => (
        <LevelBar key={key} />
      ))}
    </div>
  );
};

export const ProficiencyRow = ({ name, target }: { name: string; target: number }) => (
  <div css={{ display: 'flex', alignItems: 'center', padding: '6px 0' }}>
    <div css={{ width: '55%' }}>
      <Typography2 component="p">{truncate(name, 35)}</Typography2>
    </div>
    <div css={{ width: '30%' }}>
      <SkillSetTargetLevelBadge targetProficiency={target} />
    </div>
    <div css={{ width: '15%', position: 'relative' }}>
      <div
        css={{
          paddingRight: '38%',
          textAlign: 'right',
        }}
      >
        <Typography2 component="p">{target}</Typography2>
      </div>
    </div>
  </div>
);

export const ExtraProficiencies = ({
  extraCount,
  onViewDetails,
}: {
  extraCount: number;
  onViewDetails?: () => void;
}) => (
  <div css={{ display: 'flex' }}>
    <Typography2 component="strong">
      <FormattedMessage
        message={_t('+{number} more {number, plural, =1 {skill} other {skills}}')}
        number={String(extraCount)}
      />
    </Typography2>
    <Spacer size={8} />
    <Button variant="ghost" size="small" onClick={onViewDetails}>
      {_t('view details')}
    </Button>
  </div>
);
